export default "__VITE_ASSET__T3G0iKz4__"